import { Draggable, Droppable } from '@hello-pangea/dnd'
import clsx from 'clsx'
import { exportPathsFromHtmlNodes } from 'components/form_builder/common/utility'
import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

const UnassignedPathItem = ({ label, path, index }) => {
  const listString = path.split('.')
  const breadCrumb = listString.filter((_, index) => index < listString.length - 1).join('.')
  const lastBreadcrumb = listString.at(-1)

  return (
    <Draggable draggableId={`unassigned-path.${path}`} index={index}>
      {(provided, snapshot) => (
        <div {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
          <li className={clsx('form-builder-unassigned-path', { active: snapshot.isDragging })}>
            <div className="dome-d-flex dome-justify-between dome-gap18">
              <div className="dome-d-flex dome-align-center dome-gap12">
                <span style={{ cursor: 'grab' }}>
                  <i className="fa-light fa-grip-vertical fa-sm dome-color-med-grey form-builder-unassigned-path-icon"></i>
                </span>
                <span className="dome-p2 dome-color-darkest-grey">{label}</span>
              </div>
              <div>
                <span className="dome-p3 dome-color-lite-grey">{breadCrumb ? `${breadCrumb}.` : ''}</span>
                <span className="dome-p3 dome-color-darkest-grey">{lastBreadcrumb}</span>
              </div>
            </div>
          </li>
        </div>
      )}
    </Draggable>
  )
}

export default function UnassignedPaths() {
  const { field_defs, html_nodes } = useSelector((state) => state.fields)

  const unassignedPaths = useMemo(() => {
    const pathsFromHtmoNodes = exportPathsFromHtmlNodes(html_nodes)
    const pathsSet = new Set(pathsFromHtmoNodes)
    return Object.entries(field_defs).filter(([key, field]) => {
      if (!pathsSet.has(key)) return true
    })
  }, [field_defs, html_nodes])

  return (
    <Droppable droppableId="form-builder-unassignedpath-droppable">
      {(droppableProvided, snapshot) => {
        return (
          <div ref={droppableProvided.innerRef} {...droppableProvided.droppableProps}>
            <div className="dome-d-flex dome-flex-column dome-gap6">
              <div className="dome-d-flex dome-gap6 dome-align-center">
                <span className="dome-p2 dome-color-darkest-grey dome-text-w500">unassigned paths</span>
                <span className="dome-p2 dome-color-aqua">{unassignedPaths.length}</span>
              </div>
              <ul
                style={{ listStyle: 'none', margin: 0, padding: 0 }}
                className="dome-d-flex dome-flex-column dome-gap6"
              >
                {unassignedPaths.map(([key, field], index) => (
                  <UnassignedPathItem key={key} label={field.label} path={key} index={index} />
                ))}
              </ul>
              {droppableProvided.placeholder}
            </div>
          </div>
        )
      }}
    </Droppable>
  )
}
